import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/meucorreios/dialog.css';
import '../../../assets/css/meucorreios/icones-correios.css';
import Input from '../../../components/form/Input';
import InputCadastro from '../../../components/form/InputCadastro';
import InputRazaoSocial from '../../../components/form/InputRazaoSocial';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { createFormSchemas } from './FormSchema';
import {
  ENVIAR_TOKEN,
  VALIDAR_E_ENVIAR_TOKEN_PJ,
} from '../../../services/meuCorreios';
import { ALTERAR_MEUCORREIOS_PJ } from '../../../services/meuCorreios';

import InputToken from '../../../components/form/InputToken';
import useFetch from '../../../components/hooks/useFetch';
import { abreAlertaDialog } from '../../../components/modal/AlertaDialog';
import { getIPAddress } from '../../../components/utils/GetIPAddress';
import { toast } from 'react-toastify';
import '../../../assets/css/custom-toast.css';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

function FormAlterarDadosPJBrasil() {
  const { t } = useTranslation();
  const { formSchemaAlteraDadosPJ } = createFormSchemas(t);
  const methods = useForm({ resolver: yupResolver(formSchemaAlteraDadosPJ) });
  const [ipAddress, setIpAddress] = useState('');
  const { request: requestRFB, data: dadosRFB } = useFetch();
  const location = useLocation();
  const dados = location.state;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
  }, []);
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };

  const formatarCnpj = (cnpj) => {
    if (!cnpj) return '';

    const cnpjLimpo = cnpj.toString().replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    if (cnpjLimpo.length !== 14) return cnpj;

    return `${cnpjLimpo.slice(0, 2)}.${cnpjLimpo.slice(2, 5)}.${cnpjLimpo.slice(5, 8)}/${cnpjLimpo.slice(8, 12)}-${cnpjLimpo.slice(12, 14)}`;
  };
  const [modalAbertoDados, setModalAbertoDados] = React.useState(true);
  const [modalAbertoToken, setModalAbertoToken] = React.useState(false);
  React.useEffect(() => {
    //setSexo(dados?.usuarioExternoPF.sexo);
  }, [dados]);
  //const [sexo, setSexo] = React.useState();
  const { request } = useFetch();
  const openModalToken = () => {
    setModalAbertoDados(false);
    setModalAbertoToken(true);
  };

  const [nome, setNome] = React.useState();
  const [nomeFantasia, setNomeFantasia] = React.useState();
  const handleSubmit = async (data) => {
    if (
      dados.nome != data.nome ||
      dados.usuarioExternoPJ.nomeFantasia != data.nomeFantasia
    ) {
      data.preventDefault;
      setNome(data.nome);
      setNomeFantasia(data.nomeFantasia);

      // if (meioEnvio == 'E') {
      // const token = {
      //   meioEnvio: meioEnvio,
      //  funcionalidade: 'ALTERAR_DADOS',
      //email: dados.email,
      //};
      const dadosEnviar = {
        nomeFantasia: data.nomeFantasia.trim().toUpperCase(),
        razaoSocial: data.nome,
        cnpj: dados.usuarioExternoPJ.cnpj,
        idCorreios: dados.idCorreios,
        tipoUsuario: 'PJ',
        sediadaForaBrasil: 'N',
        token: { meioEnvio: meioEnvio, funcionalidade: 'ALTERAR_DADOS' },
      };
      const { response } = await request(
        VALIDAR_E_ENVIAR_TOKEN_PJ(dadosEnviar, ipAddress),
      );
      if (response.ok) {
        if (meioEnvio == 'E') {
          abreAlertaDialog(t('principal.messages.success.token_sent_email'));
        } else {
          abreAlertaDialog(t('principal.messages.success.token_sent_phone'));
        }
        openModalToken();
      }
    } else {
      abreAlertaDialog(t('principal.messages.success.data_not_changed'));
    }
  };
  const [meioEnvio, setMeioEnvio] = React.useState('E');
  const handleMeioEnvio = (event) => {
    setMeioEnvio(event.target.value);
  };
  const alterar = async () => {
    const token =
      document.getElementById('confirmarSenha1').value +
      document.getElementById('confirmarSenha2').value +
      document.getElementById('confirmarSenha3').value +
      document.getElementById('confirmarSenha4').value +
      document.getElementById('confirmarSenha5').value +
      document.getElementById('confirmarSenha6').value;
    if (token.length < 6) {
      abreAlertaDialog(t('principal.messages.validation.token_digits_required'));
    } else {
      const dadosEnviar = {
        idCorreios: dados.idCorreios,
        nome: nome.trim().toUpperCase(),
        nomeFantasia: nomeFantasia.trim().toUpperCase(),
        sediadaForaBrasil: 'N',
        token: token,
      };
      const { response } = await request(
        ALTERAR_MEUCORREIOS_PJ(dadosEnviar, ipAddress),
      );
      if (response.ok) {
        abreAlertaDialog(t('principal.edit_data.messages.updated_success'));
        setModalAbertoToken(false);
        navigate('/principal');
      }
    }
  };
  const fechar = (ev) => {
    ev.preventDefault();
    setModalAbertoToken(false);
    navigate('/principal');
  };
  const handleReset = () => {
    const form = document.getElementById('formAlterarDados');
    const campos = form.querySelectorAll('input');
    campos.forEach((campo) => {
      campo.value = '';
    });
  };
  const reenviaToken = async () => {
    const token = {
      meioEnvio: meioEnvio,
      funcionalidade: 'ALTERAR_DADOS',
      //email: dados.email,
    };
    const { response } = await request(ENVIAR_TOKEN(dados.idCorreios, token));
    if (response.ok) {
      if (meioEnvio == 'E') {
        abreAlertaDialog(t('principal.messages.success.token_sent_email'));
      } else {
        abreAlertaDialog(t('principal.messages.success.token_sent_phone'));
      }
      openModalToken();
    }
  };

  return (
    <>
      {modalAbertoDados ? (
        <div className="conteudo">
          <div id="cadastro-pf" className="card bg-superficie elev5">
            <form
              id="formAlterarDados"
              onSubmit={methods.handleSubmit(handleSubmit)}
            >
              <div className="dialog-main">
                <div className="campo-txt">
                  <label className="subtitulo-p" htmlFor="input-cpf">
                    {t('telaPrincipal.cnpj')}
                  </label>

                  <div className="input-container">
                    <Input
                      type="text"
                      id="cnpj"
                      name="cnpj"
                      placeholder=""
                      disabled
                      defaultValue={formatarCnpj(dados?.usuarioExternoPJ?.cnpj)}
                      {...formMethods}
                    />
                  </div>
                  <div className="mensagem legenda"></div>
                </div>
                <div className="campo-txt">
                  <label className="subtitulo-p" htmlFor="input-nome">
                    {t('cadastro.forms.labels.company_name')}
                  </label>

                  <div className="campos">
                    <InputRazaoSocial
                      type="text"
                      id="nome"
                      name="nome"
                      placeholder=""
                      maxLength="150"
                      defaultValue={dados?.nome}
                      {...formMethods}
                    />
                  </div>
                  <div className="mensagem legenda"></div>
                </div>
                <div className="campo-txt">
                  <label className="subtitulo-p" htmlFor="input-nomeFantasia">
                    {t('cadastro.forms.labels.trade_name')}
                  </label>

                  <div className="campos">
                    <InputCadastro
                      type="text"
                      id="nomeFantasia"
                      name="nomeFantasia"
                      maxLength="100"
                      placeholder=""
                      defaultValue={dados?.usuarioExternoPJ.nomeFantasia}
                      {...formMethods}
                    />
                  </div>
                  <div className="mensagem legenda"></div>
                </div>

                <div className="receber-token radio-container">
                  <p className="">
                    {t('principal.edit_data.token_delivery_question')}
                  </p>

                  <label className="radio">
                    <Input
                      type="radio"
                      id="E"
                      name="meioEnvio"
                      value="E"
                      checked={meioEnvio === 'E'}
                      onChange={handleMeioEnvio}
                      {...formMethods}
                    />
                    <div className="subtitulo-p">{t('principal.forms.labels.email_option')}</div>
                  </label>

                  <label className="radio">
                    <Input
                      type="radio"
                      id="C"
                      name="meioEnvio"
                      value="C"
                      //disabled="true"
                      checked={meioEnvio === 'C'}
                      onChange={handleMeioEnvio}
                      {...formMethods}
                    />
                    <div className="subtitulo-p">{t('principal.forms.labels.phone_option')}</div>
                  </label>
                </div>
              </div>
              <br />
              <br />
              <div className="dialog-footer">
                <button className="btn-txt btn-fecha-dialog" onClick={fechar}>
                  {t('principal.forms.buttons.cancel')}
                </button>
                <button className="btn-pre" id="btn-dados" type="submit">
                  {t('principal.forms.buttons.change')}
                </button>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <form>
          <div id="finaliza-cadastro" className="conteudo">
            <div id="bem-vindo" className="card bg-superficie elev5">
              <img
                alt="Imagem de perfil da Carol"
                id="img-carol-boasvindas"
                src="/images/carol-perfil.png"
              />

              <h2>{t('principal.forms.titles.finalize_change')}</h2>

              <p className="txt-finalizacao">
                {t('principal.edit_data.finalize_message')}
              </p>
              <div className="campo-txt">
                <InputToken />
              </div>
              <div className="btns-row">
                <button
                  id="btn-reenviar"
                  type="button"
                  className="btn-cont"
                  onClick={reenviaToken}
                >
                  {t('principal.forms.buttons.resend_code')}
                </button>

                <button
                  id="btn-finalizar"
                  type="button"
                  className="btn-pre"
                  onClick={alterar}
                >
                  {t('principal.forms.buttons.finalize')}
                </button>
                <button className="btn-txt btn-fecha-dialog" onClick={fechar}>
                  {t('principal.forms.buttons.cancel')}
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  );
}
export default FormAlterarDadosPJBrasil;
